// @flow

import React from 'react';
import { StyledPrice, Title } from './optionPrice.styled';
import type { OptionPrice as Props } from './types';
import Price from '../../../price';

export default ({
  title, price, active, postfix,
}: Props) => (
  <>
    <Title
      active={active}
    >
      {title}
    </Title>
    <StyledPrice
      active={active}
    >
      <Price
        amount={price}
        displayPrefix
        displayCurrencyText
        decimalDash={false}
        postfix={postfix}
      />
    </StyledPrice>
  </>
);
